import { Snackbar, Alert, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSnackbarStore } from '../../hooks/use-snackbar';
import { BaseSnackbarProviderProps } from './types';

export function BaseSnackbarProvider({
  onContactSupport,
  anchorVertical = 'top',
  anchorHorizontal = 'center',
  topOffset = 64,
  stackSpacing = 70,
}: BaseSnackbarProviderProps = {}) {
  const { t } = useTranslation('common');
  const snackbars = useSnackbarStore((state) => state.snackbars);
  const removeSnackbar = useSnackbarStore((state) => state.removeSnackbar);

  const handleContactSupport = () => {
    if (onContactSupport) {
      onContactSupport();
    }
  };

  return (
    <>
      {snackbars.map((snackbar, index) => {
        const topPosition = anchorVertical === 'top' 
          ? topOffset + index * stackSpacing 
          : undefined;
        
        const bottomPosition = anchorVertical === 'bottom'
          ? topOffset + index * stackSpacing
          : undefined;

        return (
          <Snackbar
            key={snackbar.id}
            open
            anchorOrigin={{ vertical: anchorVertical, horizontal: anchorHorizontal }}
            style={{ 
              top: topPosition ? `${topPosition}px` : undefined,
              bottom: bottomPosition ? `${bottomPosition}px` : undefined,
            }}
            onClose={() => removeSnackbar(snackbar.id)}
          >
            <Alert
              severity={snackbar.severity}
              onClose={() => removeSnackbar(snackbar.id)}
              sx={{ minWidth: 300, maxWidth: 500 }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box>{snackbar.message}</Box>
                {snackbar.errorDetails && (
                  <Box sx={{ fontSize: '0.875rem', opacity: 0.9 }}>
                    {snackbar.errorDetails}
                  </Box>
                )}
                {snackbar.showContactSupport && (
                  <Box sx={{ mt: 0.5 }}>
                    <Button 
                      size="small" 
                      variant="outlined"
                      color="inherit" 
                      onClick={handleContactSupport}
                    >
                      {t('snackbar.contactSupport')}
                    </Button>
                  </Box>
                )}
              </Box>
            </Alert>
          </Snackbar>
        );
      })}
    </>
  );
}

